import Post from "./Post";
import { LoadingButton } from "@mui/lab";
import NotFound from "./NotFound";
import useGetPosts from "./Hooks/useGetPosts";
import { useState } from "react";
import Remove from "./Remove";
import { Stack, Typography } from "@mui/material";
import { txt } from "../../services/translation";

export default function Posts({search, tag, filter, id, courseId, onTagClick}){

    const [remove, setRemove] = useState(false)

    const queryKey = ['posts', search, tag, filter, id, courseId]

    const posts = useGetPosts(queryKey)

    const showButton = ((posts.isSuccess && posts.hasNextPage) || posts.isFetchingNextPage);

    const notFound = id && posts.isSuccess && !posts.data.pages[0]?.data?.length

    return <Stack sx={{mb: 2}}>
    
        {posts.isSuccess && <>

            {posts.data.pages.map(page => 
                page.data.map(p => 
                    <Post 
                        key={p.id}
                        post={p}
                        onTagClick={tag => onTagClick(tag)}
                        onDelete={() => setRemove([p.id, page.meta.pageNumber])}
                        queryKey={queryKey}
                        page={page.meta.pageNumber}
                        zoom={parseInt(id) === p.id}
                    />   
                )
            )}

            {!posts.data.pages[0]?.data?.length && 
                <Typography align='center' variant='span' sx={{m: 1}}>
                    <i>{txt('noPostsToDisplay')}</i>
                </Typography>
            }
            
        </>}

        {notFound && 
            <NotFound />
        }

        {showButton && 
            <LoadingButton 
                onClick={() => posts.fetchNextPage()} 
                loading={posts.isFetchingNextPage}
            >
                {txt('showMore')}
            </LoadingButton>
        }


        <Remove 
            open={Array.isArray(remove)}
            id={remove[0]}
            pageNumber={remove[1]}
            onClose={() => setRemove(false)}
            queryKey={queryKey}
        />

    </Stack>

}